import createLogger from '@ally/whisper';
const whisper = createLogger({
    silent: process.env.NODE_ENV === 'test',
    nameSpace: '@ally/metronome-ui',
    once: true,
});
export default whisper;
//# sourceMappingURL=whisper.js.map